export class AppLogo extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const size = 200;
        const strokeColor = this.getAttribute('color') || '#00ffcc';
        
        // Complex geometric pattern logic (Spirograph/Harmonic interference)
        const lines = [];
        const steps = 100;
        const radius = 80;
        const center = size / 2;

        // Generate multiple intersecting harmonic paths
        for (let i = 0; i < 5; i++) {
            let pathD = `M ${center + radius} ${center}`;
            const freq = 3 + i; // Increasing frequency
            const amp = 10 + (i * 5); 
            
            for (let angle = 0; angle <= Math.PI * 2; angle += (Math.PI * 2) / steps) {
                // Modulate radius with sine waves
                const r = radius - (Math.sin(angle * freq) * amp);
                const x = center + r * Math.cos(angle);
                const y = center + r * Math.sin(angle);
                pathD += ` L ${x} ${y}`;
            }
            pathD += ' Z'; // Close path
            lines.push(`<path d="${pathD}" fill="none" stroke="${strokeColor}" stroke-width="${1.5 - (i * 0.2)}" opacity="${0.4 + (i * 0.1)}" />`);
        }

        // Central "Core"
        lines.push(`<circle cx="${center}" cy="${center}" r="15" fill="${strokeColor}" opacity="0.8" />`);
        lines.push(`<circle cx="${center}" cy="${center}" r="8" fill="#111" />`);

        const svgContent = `
            <svg viewBox="0 0 ${size} ${size}" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <filter id="glow">
                        <feGaussianBlur stdDeviation="2.5" result="coloredBlur"/>
                        <feMerge>
                            <feMergeNode in="coloredBlur"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                </defs>
                <g filter="url(#glow)">
                    ${lines.join('')}
                </g>
            </svg>
        `;

        const style = `
            <style>
                :host {
                    display: inline-block;
                    width: 100px; /* Default size */
                    height: 100px;
                }
                :host(.large) {
                    width: 200px;
                    height: 200px;
                }
                :host(.small) {
                    width: 40px;
                    height: 40px;
                }
                svg {
                    animation: spin 60s linear infinite;
                }
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            </style>
        `;

        this.shadowRoot.innerHTML = style + svgContent;
    }
}

customElements.define('app-logo', AppLogo);
